import { createContext, useContext } from 'react';
import type { Dispatch, SetStateAction } from 'react';

export interface OverviewMetrics {
  successRate: number | null;
  p90Duration: number | null;
  duplicatePercent: number;
  errorCount: number | null;
  rangeLabel: string;
}

export interface OverviewSystemHealth {
  apiHealthy: boolean;
  databaseHealthy: boolean | null;
  storageHealthy: boolean | null;
}

type OverviewMetricsPublisher = Dispatch<SetStateAction<OverviewMetrics | null>>;

export const OverviewMetricsContext = createContext<OverviewMetricsPublisher | null>(null);
export const OverviewSystemHealthContext = createContext<OverviewSystemHealth | null>(null);

export function usePublishOverviewMetrics(): OverviewMetricsPublisher | null {
  return useContext(OverviewMetricsContext);
}

export function useOverviewSystemHealth(): OverviewSystemHealth | null {
  return useContext(OverviewSystemHealthContext);
}
